<template>
  <div class="-gif" @click="previewAsset">
    <div class="-inner">
      <div v-if="showActions && !overlay" class="-actions">
        <wt-asset-locate @locate="$emit('locate')" :asset="asset" />
        <wt-asset-remove @remove="$emit('remove')" />
        <wt-asset-add :disabled="!canAdd" @add="$emit('add')" />
      </div>
      <img :src="mixinSrc(src)" :draggable="false" />
    </div>

    <div v-if="!overlay" class="-indicators">
      <transition name="wt2-fade-fast">
        <wt-asset-used v-if="isUsed" />
      </transition>
    </div>

    <wt-asset-icons-overlay-asset
      v-if="overlay"
      :duration="displayDuration"
      :icons="iconsForOverlayAsset"
    />
    <wt-asset-icons v-else :restrictions="assetRestrictions" :icons="icons" />
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetIconsForOverlayAsset from 'components/assets/mixins/AssetIconsForOverlayAsset.vue';
import AssetIcons from 'components/assets/mixins/AssetIcons.vue';

export default {
  mixins: [AssetMixins],
  components: {
    'wt-asset-icons-overlay-asset': AssetIconsForOverlayAsset,
    'wt-asset-icons': AssetIcons,
  },

  computed: {
    src: function () {
      return (
        this.asset.metadata.thumbnail256x144Url ||
        this.asset.metadata.thumbnail160x90Url ||
        this.asset.metadata.posterUrl ||
        ''
      );
    },
  },
};
</script>
